import Dialog from "./Dialog";

/**
 * @class MessageDialog
 */
export default class MessageDialog extends Dialog {
    /**
     * @param   {String}        type
     * @param   {String}        text
     * @param   {String}        statusText
     * @param   {Array}         params
     */
    constructor(type, text, statusText, params) {
        super(0, type, text, 0, "message_dialog", 0, [], params, null);

        this._statusText = statusText;
    }

    /**
     * Clones dialog object.
     *
     * @return  {Object}
     */
    clone = () => {
        return new MessageDialog(this._type, this._text, this._statusText, this._params);
    };
}
